<div *ngIf="registration != undefined" class="row fields-group no-filter faded">
    <div class="col-12">
        <div *ngIf="showList" (click)="showList = !showList;" class="list-overlay-close"></div>
        <div class="list-title d-flex">
            <span class="d-flex w-100 pr-1 title cursor-pointer" (click)="isCollapsed = !isCollapsed">
                {{ 'reg.results' | translate }} ({{documentResultListLength ? documentResultListLength : '0'}})
                <span *ngIf="documentResultListLength > 0" class="list-header-collapse-toggle ml-auto">
                    <i class="fa fa-angle-{{isCollapsed ? 'down' : 'up'}}"></i>
                </span>
            </span>
        </div>
        <div class="row p-0 m-0 page-table expanded-list" *ngIf="!isCollapsed">
            <div class="list-group-collapse duo flex-wrap list-item-container" cdkDropList
                [cdkDropListData]="documentResultList" (cdkDropListDropped)="dropped($event)">
                <div cdkDrag
                    *ngFor="let documentResult of documentResultList; let first = first; let last = last; let i = index"
                    class="{{ disabled ? 'list-item-disabled' : 'list-item' }} {{first ? 'first' : ''}} item">
                    <div (click)="openEdit(documentResult);$event.stopPropagation();"
                        class="d-flex justify-content-between col">
                        <div class="d-flex align-items-center w-100">
                            <div>{{documentResult.requirement.name | translate}}</div>
                            <small class="mb-0 mx-2" *ngIf="documentResult.additionalInformation">
                                <i tooltip="{{documentResult.additionalInformation}}" style="cursor:help"
                                    class="fas fa-info-circle"></i>
                            </small>
                            <div class="d-flex align-items-center ml-auto mr-1">
                                <span *ngIf="documentResult.bot" class="fad fa-arrow-right-arrow-left text-warning mr-2"
                                    tooltip="{{documentResult.bot && documentResult.bot.name}}"></span>
                                <span
                                    class="badge badge-linked badge-letter mr-1 {{documentResult.linkingFileUploadPath ? '' : 'd-none'}}"
                                    [routerLink]="documentResult.linkingFileUploadPathRouterLink"
                                    tooltip="{{ 'modal.result_is_linked_with_file_upload_component' | translate }} - {{documentResult.linkingFileUploadPathTitle}}"><i class="far fa-cloud-arrow-up"></i></span>
                                <span
                                    class="btn-circle-icon btn-circle-small btn-default mr-1 {{documentResult.resultIsPhysical ? '' : 'd-none'}}"
                                    tooltip="{{ 'modal.result_is_physical' | translate }}"><i class="far fa-box"></i></span>
                                <span
                                    class="btn-circle-icon btn-circle-small btn-success mr-1 {{documentResult.resultIsDigital ? '' : 'd-none'}}"
                                    tooltip="{{ 'modal.result_is_digital' | translate }}"><i class="far fa-cloud-arrow-down"></i></span>
                                <span
                                    class="btn-circle-icon btn-circle-small btn-secondary mr-1 {{documentResult.multiple ? '' : 'd-none'}}"
                                    tooltip="{{ 'modal.result_is_multiple' | translate }}">
                                    <i class="fa-solid fa-files"></i>
                                </span>
                                <span class="list-unstyled">
                                    <span class="text-muted mr-1" *ngFor="let det of documentResult.determinants">
                                        <span class="float-left">
                                            <small>{{'general.if' | translate }} </small>
                                            <small>{{det.name}}</small>
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="determinantAllowed(documentResult)" class="d-flex align-items-center"
                            (click)="openEdit(documentResult, true); $event.stopPropagation();">
                            <det-popover [extraClasses]="hasDeterminant(documentResult) ? 'active' : ''"
                                [determinant]="documentResult.jsonDeterminants" [placement]="'top'"
                                [hasErrors]="hasError(documentResult.id)"
                                [determinantMapById]="determinantMapById"></det-popover>
                        </div>
                        <div class="d-flex align-items-center">
                            <business-key *ngIf="documentResult.requirement.businessKey" class="mr-auto"
                                [businessKey]="documentResult.requirement.businessKey"
                                [businessKeyTooltip]="'Result business key' | translate" [extraClass]="'mr-2'">
                            </business-key>
                        </div>
                        <div class="d-flex align-items-center" *ngIf="!disabled">
                            <confirmation [showTrashIcon]="true" [question]="'confirm.areyousure'"
                                [extraClasses]="'d-flex'" (click)="$event.stopPropagation();"
                                (isConfirmed)="deleteDocumentResult($event, documentResult.id)">
                            </confirmation>
                        </div>
                    </div>

                    <div *cdkDragPreview class="col-4">
                        <div>
                            {{documentResult.requirement.name | translate}}
                        </div>
                    </div>

                </div>
            </div>
            <!--
            <div class="w-100 position-relative list-item-container" *ngIf="!disabled">
                <div class="list-item item last add-item {{showList ? 'opened' : ''}}"
                        (click)="showOrAdd(); $event.stopPropagation();">
                    <div class="d-flex w-100 justify-content-between list-itemPart first">
                        <div class="{{showList ? 'hidden' : ''}}">
                            <span *ngIf="requirements?.length > 0"><i class="fal fa-plus"></i> {{'Select or add new' | translate}}</span>
                            <span *ngIf="requirements?.length == 0"><i class="fal fa-plus"></i> {{'Add new' | translate}}</span>
                        </div>
                        <input [(ngModel)]="searchRequirementFilter.name" (click)="$event.stopPropagation();" placeholder="{{ 'Search' | translate }}" type="text" class="{{showList ? '' : 'hidden'}} select-search" />
                        <span (click)="openEdit(false);$event.stopPropagation();"
                                class="btn btn-primary text-white ml-auto {{showList ? '' : 'hidden'}}">{{'Add' | translate}}</span>
                    </div>
                </div>
                <div class="w-100 list-item-group limit-height-200 vertical-scroll" *ngIf="requirements.length > 0">
                    <div *ngFor="let requirement of requirements | filterBy: searchRequirementFilter; let first = first; let last = last; let i = index"
                            (click)="addDocumentResult(requirement);$event.stopPropagation();"
                            class="list-item w-100 select-item {{showList ? '' : 'hidden'}} {{last ? 'last' : ''}}">
                        <div class="d-flex justify-content-between pr-3 list-itemPart first">
                            <div class="d-flex align-items-center w-100">
                                <div>{{requirement.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            -->
            <drawer-items class="mt-1" [items]="requirements" [title]="'reg.results'"
                (itemSelected)="addDocumentResults($event)" [openListButtonLabel]="'Select or add new'"
                [showAddButton]="true" (askForNew)="openEdit(false, false, $event)"></drawer-items>
        </div>
    </div>
</div>